<template>
    <search-summary-layout
        :search-request="searchRequest"
        :search-disabled="searchDisabled"
        :is-return-transfer="!!isReturnTransfer"
        :form-component="formComponent"
        show-date
        show-tourists
    >
        <template v-slot:title>
            {{ locationLabel + (isReturnTransfer ? ` (${$t('and_back')})` : '') }}
        </template>
    </search-summary-layout>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator'
    import SearchSummaryLayout from '~src/components/parts/searchSummaryLayout.src'
    import TransferSearchForm from '~src/components/transfers/search/forms/transferSearchForm.src'

    //TODO Hide if empty searchRequest
    @Component({
        components: {
            SearchSummaryLayout,
            TransferSearchForm,
        },
    })
    export class TransferSearchSummary extends Vue {
        @Prop({default: false, type: Boolean}) searchDisabled
        @Prop({required: true}) searchRequest
        @Prop() searchRequestReturnTransfer
        @Prop() isReturnTransfer

        @Watch('isSearchActive')
        onLoadingChange(searchActive) {
            if (searchActive) {
                this.searchForm = false
            }
        }

        get isSearchActive() {
            return transfersRuntimeStore.searchActive
        }

        get locationLabel() {
            const departureTitle =
                transfersRuntimeStore.departurePoint.title ||
                `${transfersRuntimeStore.departurePoint.name}, ${transfersRuntimeStore.departurePoint.parentName}` +
                    (transfersRuntimeStore.departurePoint.type === 'airport'
                        ? ` (${transfersRuntimeStore.departurePoint.iataCode})`
                        : '')
            const arrivalTitle =
                transfersRuntimeStore.arrivalPoint.title ||
                `${transfersRuntimeStore.arrivalPoint.name}, ${transfersRuntimeStore.arrivalPoint.parentName}` +
                    (transfersRuntimeStore.arrivalPoint.type === 'airport'
                        ? ` (${transfersRuntimeStore.arrivalPoint.iataCode})`
                        : '')

            return `${departureTitle} - ${arrivalTitle}`
        }

        get formComponent() {
            return resolveComponent('TransferSearchForm')
        }
    }

    export default TransferSearchSummary
</script>
